import * as React from 'react';
import {CarouselNext, CarouselPrevious} from './CarouselControls';
import {CarouselRoot, type CarouselRootProps} from './CarouselRoot';
import {CarouselSlide} from './CarouselSlide';
import {CarouselTrack} from './CarouselTrack';
import {CarouselViewport} from './CarouselViewport';

export type CarouselProps = CarouselRootProps & {
  children: React.ReactNode;
};

export function Carousel({children, slideCount, ...props}: CarouselProps) {
  return (
    <CarouselRoot slideCount={slideCount ?? React.Children.count(children)} {...props}>
      <CarouselViewport>
        <CarouselTrack>
          {React.Children.map(children, slide => (
            <CarouselSlide>{slide}</CarouselSlide>
          ))}
        </CarouselTrack>
      </CarouselViewport>
      <CarouselPrevious />
      <CarouselNext />
    </CarouselRoot>
  );
}
